import React__default from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KLanguageSwitcher from '../../KLanguageSwitcher/index.js';
import { StyledKLandingHeader, classes } from './styles.js';

/**
 * Keepeek landing page header
 */
var KLandingHeader = function (_a) {
    var displayAppTitle = _a.displayAppTitle, logoCentered = _a.logoCentered, logoMarginTop = _a.logoMarginTop, logoMaxHeight = _a.logoMaxHeight, logoLoginSrc = _a.logoLoginSrc, className = _a.className, appTitle = _a.appTitle, locales = _a.locales, imageComponent = _a.imageComponent, onLocaleChange = _a.onLocaleChange, loadingOptimImage = _a.loadingOptimImage, EditableSanitizeHtml = _a.EditableSanitizeHtml;
    var _b = useTranslation("refront-components"), t = _b.t, i18n = _b.i18n;
    return (React__default.createElement(StyledKLandingHeader, { className: clsx("KLandingHeader", classes.root, className), logoCentered: logoCentered, logoMaxHeight: logoMaxHeight, imageComponent: imageComponent, logoMarginTop: logoMarginTop },
        React__default.createElement(Box, { component: "h1", className: classes.logoContainer },
            ((logoLoginSrc && !imageComponent) || (logoLoginSrc && !(imageComponent === null || imageComponent === void 0 ? void 0 : imageComponent.active))) && (React__default.createElement("img", { src: logoLoginSrc, "data-testid": "logo", alt: appTitle ? t(appTitle) : "", className: classes.logo })),
            loadingOptimImage && React__default.createElement(Skeleton, { width: 80, height: 80 }),
            !loadingOptimImage &&
                logoLoginSrc &&
                !!imageComponent &&
                (imageComponent === null || imageComponent === void 0 ? void 0 : imageComponent.active) &&
                imageComponent.component(logoLoginSrc),
            displayAppTitle && !logoCentered && appTitle && (React__default.createElement(Typography, { "data-testid": "appTitleLabel", className: classes.title, variant: "h1", component: "div" },
                EditableSanitizeHtml && React__default.createElement(EditableSanitizeHtml, { labelKey: appTitle }),
                !EditableSanitizeHtml && t(appTitle)))),
        showKLanguageSwitcher(locales) && onLocaleChange && (React__default.createElement(Box, { className: classes.kLanguageSwitcherContainer },
            React__default.createElement(KLanguageSwitcher, { className: classes.kLanguageSwitcher, locales: locales !== null && locales !== void 0 ? locales : ["fr"], currentLocale: i18n.language, onChange: function (event) {
                    onLocaleChange(event.target.value);
                } })))));
};
function showKLanguageSwitcher(locales) {
    return (locales && locales.length > 1) || false;
}

export { KLandingHeader as default };
//# sourceMappingURL=index.js.map
